export default class ExecutionEntriesCtrl {

	constructor ($scope, $mdDialog, ReviewSrv, WorkPlanModalSrv) {
		$scope.activity = WorkPlanModalSrv.getVariable()
		$scope.entries = []

		$scope.close = close
		$scope.dateFormatter = dateFormatter
	
		$scope.download = (link) => {
			window.open(link)
		}

		activate()

		function close () {
			return $mdDialog.hide()
		}

		function dateFormatter (date) {
			const formattedDate = moment(date).format('dddd DD/MM/YYYY')

			return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)
		}

		function activate () {
			return getExecutionEntries($scope.activity)
		}

		function getExecutionEntries (activity) {
			const header = {
				workplanTeacherActivityId: activity.selectedActivityId,
			}

			return ReviewSrv.getExecutionEntries.post(header).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					$scope.entries = dataReturn.data
				}
			})
		}
	}

}

ExecutionEntriesCtrl.$inject = [ '$scope', '$mdDialog', 'ReviewSrv', 'WorkPlanModalSrv' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/modals/executionEntriesCtrl.js